import React from "react"
import styled from "styled-components"

interface DividerProps {
  direction?: "horizontal" | "vertical"
  margin?: string
  noLine?: boolean
  dashed?: boolean
}

const HorizontalDivider = styled.div<DividerProps>`
  margin: ${({ margin }) => (margin ? margin : "8px 0px")};
  width: 100%;
  height: ${({ noLine }) => (noLine ? "0px" : "1px")};
  background-color: ${({ color, theme, dashed }) =>
    dashed ? "transparent" : color ? theme[color] : theme.gray_300};
  ${({ dashed, color, theme }) =>
    dashed && `border-bottom: 1px dashed ${color ? theme[color] : theme.gray_300};`}
`

const VerticalDivider = styled.div<DividerProps>`
  margin: ${({ margin }) => (margin ? margin : "0px 8px")};
  width: ${({ noLine }) => (noLine ? "0px" : "1px")};
  background-color: ${({ color, theme, dashed }) =>
    dashed ? "transparent" : color ? theme[color] : theme.gray_300};
  ${({ dashed, color, theme }) =>
    dashed && `border-right: 1px dashed ${color ? theme[color] : theme.gray_300};`}
`

const Divider = (props: DividerProps) => {
  return props.direction === "horizontal" ? (
    <HorizontalDivider {...props} />
  ) : (
    <VerticalDivider {...props} />
  )
}

Divider.defaultProps = {
  direction: "horizontal",
}

export default Divider
